/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsDataMultipleWithSubmissionCycleData } from '../../models/submissions-data-multiple-with-submission-cycle-data';

export interface GetMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Params {
  id: string;
  org: string;
  submissionsIds: Array<string>;
}

export function getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet(http: HttpClient, rootUrl: string, params: GetMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsDataMultipleWithSubmissionCycleData>> {
  const rb = new RequestBuilder(rootUrl, getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.query('submissionsIds', params.submissionsIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionsDataMultipleWithSubmissionCycleData>;
    })
  );
}

getMultipleSubmissionsDataBySubmissionsCycleIdApiV2SubmissionsOrgSubmissionsCycleIdSubmissionsDataGet.PATH = '/api/v2/submissions/{org}/submissions-cycle/{id}/submissions/data';
